module.exports = __webpack_public_path__ + "static/media/599.705493(11).a96fe91b.pdf";